<template>
  <div class="account-right fixed-mp-cls">
    <orders-bread-crumb></orders-bread-crumb>
    <div class="account-card group-tab">
      <orders-account-header></orders-account-header>
      <order-tabs></order-tabs>
      <div class="account-body">
        <div id="tabsContent" class="tab-content">
          <div id="ongoing-order" class="tab-pane fade active show">
            <div class="order-lists" v-if="orders && orders.length">
              <order
                v-for="(order, index) in orders"
                :key="index + order._id"
                :order="order"
              />
            </div>
            <div v-else class="order-lists">
              <h5 class="nothing-found">{{ _T('No Ongoing Orders Found') }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Order from './Order'
import OrdersBreadCrumb from './OrdersBreadCrumb'
import OrderTabs from './OrderTabs'
import OrdersAccountHeader from './OrdersAccountHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'OngoingOrder',
  components: {
    Order,
    OrdersBreadCrumb,
    OrderTabs,
    OrdersAccountHeader,
  },
  computed: {
    ...mapGetters(['_T', 'all_customer_orders']),
    orders () {
      if (this.all_customer_orders) {
        return this.all_customer_orders.filter(
          order =>
            order.order_status === this.CONST.ORDER_STATUS_IN_PROGRESS &&
            order.future_order_datetime === '' &&
            order.order_system_status !==
              this.CONST.ORDER_SYSTEM_STATUS_REJECTED &&
            order.order_system_status !==
              this.CONST.ORDER_SYSTEM_STATUS_CANCELLED
        )
      }
      return []
    },
  },
  beforeMount () {
    this.$store.dispatch('load_orders', true)
  },
   
}
</script>

<style lang="scss" scoped>
.account-card {
  box-shadow: 0px 4px 34px rgba($black, 0.07);
  margin: $px18 0 $px30;
  border-radius: $px10;
  &.group-tab {
    position: relative;
  }
}
.order-lists {
  padding: $px30;
  overflow: hidden;
  max-height: $px500;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .nothing-found {
    font-weight: bold;
  }
}

@media (max-width: 1199px) {
  .order-lists {
    padding: $px20;
  }
}
@media (max-width: 991px) {
  .order-lists {
    padding: $px20 $px10;
  }
}
@media (max-width: 575px) {
  .account-right {
    .account-card {
      margin-top: 0;
      box-shadow: none;
      border-radius: 0;
    }
  }
  .order-lists {
    max-height: 100%;
  }
}
</style>
